<template>
	<div class="canteen1">
        <img src="../assets/shitang1.png" alt="" style="width: 100%;">
        <br/>
        <br/>
        <main>
            <span>好吃由你定，美味共分享，快来票选你最心仪的3款饮料物资</span>
            <br/>
            <br/>
            <br/>
        </main>

        <van-checkbox-group v-model="result" ref="checkboxGroup" style="margin: 0 20px; background-color: #fff;" :max="3">
            <van-checkbox :name=i+1 v-for="(item,i) in list">{{ item }}</van-checkbox>
        </van-checkbox-group>
        
        <br/>
        <br/>
        <footer style="padding: 0 20px;">
            <van-button type="info" size="small" @click="submit()" style="width: 100%;">提交</van-button>
        </footer>
        
    </div>
</template>

<script>
    import shitang from "../config/option.js"
    import { url } from '../router/api';

	export default{
        data() {
            return {
                result: [],
                list:shitang.shitang
            };
        },
        
        mounted() {
        },

        methods: {
            submit() {
                if(this.result.length=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请选择物资',
                    }).then(() => {});
                } else {
                    this.$dialog.confirm({
                        title: '提示',
                        message: '是否提交',
                    }).then(() => {
                        this.axios.get(url + 'complaint/wuZi', {
                            params:{
                                result:this.result,
                            }
                        }).then(res=> {
                            this.$dialog.alert({
                                title: '提示',
                                message: '提交成功',
                            }).then(() => {
                                this.result = [];
                            });
                        }).catch(err=> {});
                    }).catch(() => {});
                }
            },
        }
    }
</script>

<style scoped="cabteeb" lang='less'>
    .canteen1 {
        background-color: #A9B46E;
        padding-bottom: 40px;
        main {
            padding:0 20px;
        }
        span {
            color: #FFF;
            display: inline-block;
            line-height: 30px;
        }
        .van-checkbox {
            border-bottom: solid 1px;
            padding: 10px 0 10px 10px;
        }
    }
</style>